import BaseSchema from "./base";

class SampleFlask extends BaseSchema {
  static primaryKey = "uuid";
  static tableName = "sampleFlasks";
  static fields = [
    "uuid",
    "createdAt",
    "updatedAt",
    "installation",
    "name",
    "samples",
    "tryNumber",
    "reference",
    "analysisCodes",
    "type",
    "laboratory",
  ];

  static dateFields = ["createdAt", "updatedAt"];

  static relatedFields = {
    sampleObjects: {
      m2m: true,
      owner: true,
      relatedKey: "samples",
      tableName: "samples",
    },
    installationObject: {
      field: "installation",
      tableName: "installations",
    },
  };
}

export default SampleFlask;
